import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyBottomBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      const scrolledPastHero = window.scrollY > 600;
      // Hide when CTA section is in view
      const ctaSection = document.getElementById('cta');
      let ctaInView = false;
      if (ctaSection) {
        const rect = ctaSection.getBoundingClientRect();
        // If the top of the CTA section is above the bottom of the viewport
        ctaInView = rect.top < window.innerHeight;
      }
      setIsVisible(scrolledPastHero && !ctaInView);
    };
    window.addEventListener('scroll', handleScroll);
    // Initial check
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-159">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-white/90 backdrop-blur-md border-t-2 border-[#722F37] py-4 px-6 shadow-[0_-10px_30px_rgba(0,0,0,0.1)]" data-id="element-160">
          <div className="max-w-3xl mx-auto flex items-center justify-between gap-4" data-id="element-161">
            <div className="hidden sm:block" data-id="element-162">
              <p className="text-[#2D2D2D] font-bold text-lg" data-id="element-163">Ebook              </p>
              <p className="text-[#722F37] font-bold text-xl" data-id="element-164">$8.900 ARS</p>
            </div>
            <div className="sm:hidden text-[#722F37] font-bold text-xl" data-id="element-165">
              $8.900
            </div>

            <motion.a href="#cta" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} animate={{
          scale: [1, 1.05, 1],
          boxShadow: ['0 0 0 0 rgba(5, 150, 105, 0)', '0 0 0 10px rgba(5, 150, 105, 0.2)', '0 0 0 0 rgba(5, 150, 105, 0)']
        }} transition={{
          duration: 2,
          repeat: Infinity,
          repeatType: 'reverse'
        }} className="bg-[#059669] text-white px-6 py-3 rounded-lg text-lg font-bold shadow-[0_5px_15px_-3px_rgba(5,150,105,0.4)] hover:bg-[#047857] transition-colors whitespace-nowrap" data-id="element-166">
              Descargar Ahora
            </motion.a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}